import {ChargedDay, GetEvChargeSummaryResponse} from '@di-shared/api/di/__generated';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import Environment from '@di-shared/features/environment/Environment';
import EvBatteryChargingHabitBottomSheetEU from '@di-shared/features/home/kr/ev-battery/monitor/EvBatteryChargingHabitBottomSheetEU';
import EvBatteryChargingHabitBottomSheetKR, {
  DEFAULT_CAUTION_LEVEL,
} from '@di-shared/features/home/kr/ev-battery/monitor/EvBatteryChargingHabitBottomSheetKR';
import EvBatteryChargingHabitBottomSheetNa from '@di-shared/features/home/na/ev-battery/EvBatteryChargingHabitBottomSheet.na';
import useCldrDatetimeFormatter from '@di-shared/utils/useCldrDatetimeFormatter';
import {parseDateWithFormat} from '@shared/dateUtils';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 300;

function EvBatteryChargingHabitBottomSheetPage() {
  const chargedDays = window.data.chargedDays as unknown as ChargedDay[];
  const {avgMinSoc, avgMaxSoc} = window.data.summaryData as unknown as GetEvChargeSummaryResponse;
  const roundedAvgMinSoc = Math.round(avgMinSoc);
  const roundedAvgMaxSoc = Math.round(avgMaxSoc);
  const CldrDatetimeFormatter = useCldrDatetimeFormatter();

  const showCautionZone = chargedDays.some(({minSoc}) => minSoc < DEFAULT_CAUTION_LEVEL);
  const graphItems = chargedDays.map(({minSoc, maxSoc, chargedDate}) => {
    const parsedDate = parseDateWithFormat(chargedDate);
    const roundedMinSoc = Math.round(minSoc);
    const roundedMaxSoc = Math.round(maxSoc);
    return {
      start: roundedMinSoc,
      end: roundedMaxSoc,
      title: parsedDate ? CldrDatetimeFormatter.format(parsedDate, 'Md') : '',
      tooltipText: `${parsedDate ? CldrDatetimeFormatter.format(parsedDate, 'yMMMd') : ''}\n${roundedMinSoc}% → ${roundedMaxSoc}%`,
    };
  });
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <>
        <Environment.Kr>
          <EvBatteryChargingHabitBottomSheetKR
            onExit={() => window.bottomSheetClose(null)}
            graphItems={graphItems}
            showCautionZone={showCautionZone}
            avgMinSoc={roundedAvgMinSoc}
            avgMaxSoc={roundedAvgMaxSoc}
          />
        </Environment.Kr>
        <Environment.Eu>
          <EvBatteryChargingHabitBottomSheetEU
            onExit={() => window.bottomSheetClose(null)}
            graphItems={graphItems}
            showCautionZone={showCautionZone}
            avgMinSoc={roundedAvgMinSoc}
            avgMaxSoc={roundedAvgMaxSoc}
          />
        </Environment.Eu>
        <Environment.Na>
          <EvBatteryChargingHabitBottomSheetNa
            onExit={() => window.bottomSheetClose(null)}
            graphItems={graphItems}
            showCautionZone={showCautionZone}
            avgMinSoc={roundedAvgMinSoc}
            avgMaxSoc={roundedAvgMaxSoc}
          />
        </Environment.Na>
      </>
    </BottomSheetWebViewWrapper>
  );
}

export default EvBatteryChargingHabitBottomSheetPage;
